import React, { useState } from "react";
import axios from "axios";
import { iconDemo } from "utils/constants";
import { useNavigate } from "react-router-dom";
import AppModal from "components/ui/AppModal/AppModal";
// import loginBackVideo from "assets/images/VídeoBackGround.mp4";
import styles from "./auth.module.css";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [feedbackModal, setFeedbackModal] = useState({
    open: false,
    variant: "custom",
    title: "",
    message: "",
    confirmText: "OK"
  });

  const closeFeedbackModal = () =>
    setFeedbackModal(prev => ({ ...prev, open: false }));

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/users/recover-password`,
        { email }
      );
      setFeedbackModal({
        open: true,
        variant: "success",
        title: "E-mail enviado!",
        message: response.data.message
      });
    } catch (error) {
      setFeedbackModal({
        open: true,
        variant: "error",
        title: "Erro!",
        message: "Erro ao enviar o e-mail de redefinição."
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.root}>
{/* <video autoPlay muted loop className={styles.videoBg}>
        <source src={loginBackVideo} type="video/mp4" />
      </video> */}
      <div className={styles.overlay} />

      <div className={styles.card}>
        <div className={styles.logoWrap}>
          <img src={iconDemo} alt="Vertex4D" className={styles.logo} />
        </div>
        <h1 className={styles.title}>Esqueceu sua senha?</h1>
        <p className={styles.subtitle}>
          Informe seu e-mail e enviaremos as instruções para redefinição.
        </p>

        <form onSubmit={handleSubmit} noValidate>
          <div className={styles.formGroup}>
            <label className={styles.label}>Email</label>
            <input
              type="email"
              className={styles.input}
              placeholder="seu@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className={`${styles.btn} ${styles.btnPrimary}`}
            disabled={loading}
          >
            {loading ? <><div className={styles.spinner} /> Enviando...</> : "Redefinir senha"}
          </button>
        </form>

        <p className={styles.linkRow}>
          Lembrou a senha?{" "}
          <button className={styles.link} onClick={() => navigate("/login")}>
            Acessar
          </button>
        </p>
      </div>

      <AppModal
        isOpen={feedbackModal.open}
        onClose={closeFeedbackModal}
        allowOutsideClick={true}
        variant={feedbackModal.variant}
        title={feedbackModal.title}
        message={feedbackModal.message}
        confirmText={feedbackModal.confirmText}
        cancelText={null}
        onConfirm={closeFeedbackModal}
        onCancel={closeFeedbackModal}
      />
    </div>
  );
};

export default ForgotPassword;
